import { render, staticRenderFns } from "./Voting.vue?vue&type=template&id=11610d56&scoped=true"
import script from "./Voting.vue?vue&type=script&lang=js"
export * from "./Voting.vue?vue&type=script&lang=js"
import style0 from "./Voting.vue?vue&type=style&index=0&id=11610d56&prod&lang=scss&scoped=true"
import style1 from "./Voting.vue?vue&type=style&index=1&id=11610d56&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11610d56",
  null
  
)

export default component.exports